/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useMemo } from "react";
import moment from "moment";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { Box, FormControl, MenuItem, Select } from "@mui/material";

type HostPayoutItem = {
    _id: string;
    amount: number;
    status: string;
    createdAt: string;
    userDetails?: {
        email?: string;
        countryCode?: string;
        phoneNumber?: string;
        firstName?: string;
        lastName?: string;
        _id?: string
    };
};

type HostPayoutListProps = { data: HostPayoutItem[]; onUpdateStatus?: (id: string, status: "APPROVED" | "REJECTED") => void; showActions?: boolean };

const HostPayoutList: React.FC<HostPayoutListProps> = ({ data, onUpdateStatus, showActions = true }) => {

    const [actionByRow, setActionByRow] = useState<Record<string | number, string>>({});
    // Multiselect temporarily disabled

    const rows = useMemo(() => {
        const formatDate = (iso: string) => {
            try {
                return moment(iso).format("DD MMM YYYY, hh:mm A");
            } catch {
                return "";
            }
        };
        return (data || []).map((item) => {
            const firstName = item?.userDetails?.firstName || "";
            const lastName = item?.userDetails?.lastName || "";
            const HostID = item?.userDetails?._id || "";
            const countryCode = item?.userDetails?.countryCode || "";
            const phoneNumber = item?.userDetails?.phoneNumber || "";
            const name = `${firstName} ${lastName}`.trim() || "-";
            const email = item?.userDetails?.email || "-";
            const phone = countryCode && phoneNumber ? `${countryCode} ${phoneNumber}` : "-";
            const statusRaw = String(item?.status || "").toUpperCase();
            const status = statusRaw === "APPROVED" ? "paid" : statusRaw === "REJECTED" ? "rejected" : "pending";
            return {
                id: item._id, // row id must be the unique payout request id
                requestId: item._id,
                hostId: HostID,
                name,
                email,
                phone,
                avatar: "/static/images/user_placeholder.png",
                requestedAmount: Number(item.amount) || 0,
                totalAmount: Number(item.amount) || 0,
                status,
                date: formatDate(item.createdAt),
            };
        });
    }, [data]);

    const currency = (val: number) => `AED ${val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const columns: GridColDef<(typeof rows)[number]>[] = [
        {
            flex: 1,
            minWidth: 240,
            field: "user",
            headerName: "requestd by(Host Details)",
            editable: false,
            sortable: false,
            renderCell: (params) => {
                const avatar = params?.row?.avatar;
                const name = params?.row?.name;
                const email = params?.row?.email;
                const phone = params?.row?.phone;
                return (
                    <div className="user_block">
                        <figure>
                            <img src={avatar} alt="" />
                        </figure>
                        <div>
                            <p><b>{name}</b></p>
                            <p><span>{email}</span></p>
                            <p><span>{phone}</span></p>
                        </div>
                    </div>
                )
            }
        },
        {
            minWidth: 120,
            field: "requestId",
            headerName: "Request ID",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <p className="c_primary"><strong>{'-'}</strong></p>
            )
        },

        {
            minWidth: 160,
            field: "totalAmount",
            headerName: "Total Amount",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <p className="c_success"><strong>{currency(Number(params?.row?.totalAmount) || 0)}</strong></p>
            )
        },
        {
            minWidth: 120,
            field: "status",
            headerName: "Status",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const status = params?.row?.status;
                const statusClass = status === 'paid' ? 'c_success' : 'c_warning';
                return (
                    <span className={`status_badge ${statusClass}`}>
                        {status?.charAt(0).toUpperCase() + status?.slice(1)}
                    </span>
                )
            }
        },
        {
            minWidth: 160,
            field: "date",
            headerName: "Date",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            minWidth: 200,
            field: "action",
            headerName: "Action",
            editable: false,
            sortable: false,
            renderCell: (params) => {
                const current = actionByRow[params.row.id] || "";
                {
                    console.log(params?.row?.hostId, "HOST");
                }
                return (
                    <Box sx={{ minWidth: 160 }}>
                        <FormControl fullWidth size="small">
                            <Select
                                displayEmpty
                                value={current}
                                onChange={(e) => {
                                    const value = String(e.target.value);
                                    setActionByRow(prev => ({ ...prev, [params.row.id]: value }));
                                    if (onUpdateStatus) {
                                        const normalized = value === "approve" ? "APPROVED" : "REJECTED";
                                        onUpdateStatus(String(params?.row?.id), normalized);
                                    }
                                }}
                                renderValue={(selected) => {
                                    if (!selected) {
                                        return <span className="btn_text">Select Action</span>;
                                    }
                                    return String(selected).charAt(0).toUpperCase() + String(selected).slice(1);
                                }}
                            >
                                <MenuItem value={"approve"}>Approve</MenuItem>
                                <MenuItem value={"reject"}>Reject</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                )
            }
        },
    ];

    let hidden: string[] = [];
    if (!showActions) hidden.push("action");
    return (
        <>
            <div className="table_header">
                <div className="left_s"></div>
                <div className="right_s"></div>
            </div>
            <div className="sorting_table">
                <TableComponent
                    columns={columns?.filter((item) => !hidden.includes(item.field))}
                    rows={rows}
                    getRowId={(row: any) => row.id}
                />
            </div>
        </>
    );
};

export default HostPayoutList;


